<template>
  <div class="scanner-settings pa-4">
    <h3 class="mb-1">Scanner type</h3>
    <p class="grey--text mb-4">
      Applies to <strong>this device only</strong>. Set it to match the hardware physically
      connected here — the built-in camera, or a QR scanner.
    </p>

    <v-btn-toggle :value="scannerType" mandatory @change="onChange">
      <v-btn value="camera">
        <v-icon left>mdi-camera</v-icon>
        Camera Scanner
      </v-btn>
      <v-btn value="qrscanner">
        <v-icon left>mdi-qrcode-scan</v-icon>
        QR Scanner
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ScannerSettings",
  computed: {
    ...mapGetters(["scannerType"]),
  },
  methods: {
    ...mapActions(["setScannerType"]),
    onChange(value) {
      if (value) this.setScannerType(value);
    },
  },
};
</script>
